import { createStore } from "@stencil/store";
import { Group } from "@sworkit/api";
//todo, this isn't very useful right now because we go through the whole list every time the org groups change.
//also we call getOrgGroups in a lot of places
//we should store the org groups here with their names mapped and make updates only on load or on group change
interface PortalGroupsState {
  orgGroups: Group[];
  groupNameMap: { [key: string]: string };
}

const { state, onChange } = createStore<PortalGroupsState>({
  orgGroups: [],
  groupNameMap: {},
});

onChange("orgGroups", (groups: Group[]) => {
  groups.forEach((group) => {
    if (group.id) {
      state.groupNameMap[group.id] = group?.name || "";
    }
  });
});

const portalGroupsState = state;
export default portalGroupsState;
